import { merge } from 'ramda';
import {
  FAIL_IMPORT_FROM_ARGOS,
  SUCCESS_IMPORT_FROM_ARGOS,
  REQUEST_IMPORT_FROM_ARGOS,
  REQUEST_EXPORT_USER_CARDS,
  SUCCESS_EXPORT_USER_CARDS,
  FAIL_EXPORT_USER_CARDS,
  SHOW_USER_CARDS_EXPORT_INFO,
  HIDE_USER_CARDS_EXPORT_INFO
} from 'src/store/actions/importFromArgosActions';

const initialState = {
  fetching: false,
  exportFetching: false,
  errors: [],
  cardInfo: { list: [], isOpen: false }
};

const impoortFormArgos = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_IMPORT_FROM_ARGOS:
      return merge(state, { fetching: true });
    case SUCCESS_IMPORT_FROM_ARGOS:
      return merge(state, { fetching: false });
    case FAIL_IMPORT_FROM_ARGOS:
      return merge(state, { fetching: false, errors: action.error });
    case REQUEST_EXPORT_USER_CARDS:
      return merge(state, { exportFetching: true });
    case SUCCESS_EXPORT_USER_CARDS:
      return merge(state, { exportFetching: false });
    case FAIL_EXPORT_USER_CARDS:
      return merge(state, { exportFetching: false, errors: action.error });
    case SHOW_USER_CARDS_EXPORT_INFO:
      return merge(state, {
        cardInfo: { list: action.list, isOpen: true }
      });
    case HIDE_USER_CARDS_EXPORT_INFO:
      return merge(state, {
        cardInfo: { ...state.cardInfo, isOpen: false }
      });
    default:
      return state;
  }
};

export default impoortFormArgos;
